// src/pages/MyProfile.jsx
import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import api from "../api";
import BottomNav from "../components/BottomNav";
import "./MyProfile.css";

const MyProfile = () => {
  const { user, setUser, logout } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [email, setEmail] = useState(user?.email || "");
  const [mobile, setMobile] = useState(user?.mobile || "");
  const [saving, setSaving] = useState(false);
  const [bookRequests, setBookRequests] = useState([]);

  useEffect(() => {
    setName(user?.name || "");
    setEmail(user?.email || "");
    setMobile(user?.mobile || "");
  }, [user]);

  useEffect(() => {
    const fetchRequests = async () => {
      try {
        const res = await api.get("/books/requests");
        setBookRequests(res.data.requests || []);
      } catch (err) {
        console.error(err);
        setBookRequests([]);
      }
    };
    fetchRequests();
  }, []);

  const handleSaveProfile = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const res = await api.put("/auth/me", { name, email, mobile });
      setUser(res.data.user);
      alert("Profile updated");
    } catch (err) {
      console.error(err);
      alert("Error updating profile");
    } finally {
      setSaving(false);
    }
  };

  const handleRequestAction = async (requestId, action) => {
    try {
      await api.post(`/books/requests/${requestId}/${action}`);
      setBookRequests((prev) => prev.filter((r) => r._id !== requestId));
    } catch (err) {
      console.error(err);
      alert("Error updating request");
    }
  };

  return (
    <div className="profile-page">

      {/* TOP PROFILE CARD */}
      <div className="profile-top-card">
        <img
          src={`https://ui-avatars.com/api/?name=${name}&background=f9789d&color=fff&rounded=true&size=128`}
          alt="avatar"
          className="profile-avatar"
        />

        <h3 className="profile-name">{name}</h3>
        <p className="profile-mobile">📱 {mobile}</p>
        {/* {email && <p className="profile-email">✉️ {email}</p>} */}
      </div>

      {/* ACCORDION START */}
      <div className="profile-content">

        <div className="accordion" id="profileAccordion">

          {/* PROFILE DETAILS */}
          <div className="accordion-item profile-acc-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button collapsed profile-acc-btn"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#profileInfo"
              >
                <i className="bi bi-person-circle section-icon"></i>
                Profile Information
                <i className="bi bi-chevron-down acc-arrow ms-auto"></i>
              </button>
            </h2>

            <div
              id="profileInfo"
              className="accordion-collapse collapse"
              data-bs-parent="#profileAccordion"
            >
              <div className="accordion-body">

                <form onSubmit={handleSaveProfile} className="fade-in">

                  <label className="form-label fw-semibold mt-2">Name</label>
                  <input
                    className="form-control profile-input"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />

                  <label className="form-label fw-semibold mt-3">Email</label>
                  <input
                    type="email"
                    className="form-control profile-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />

                  <label className="form-label fw-semibold mt-3">Mobile Number</label>
                  <input
                    className="form-control profile-input"
                    value={mobile}
                    disabled
                  />

                  <button className="btn btn-save w-100 ripple mt-3" disabled={saving}>
                    {saving ? "Saving..." : "Save Profile"}
                  </button>
                </form>

              </div>
            </div>
          </div>

          {/* BOOK REQUESTS */}
          <div className="accordion-item profile-acc-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button collapsed profile-acc-btn"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#bookRequests"
              >
                <i className="bi bi-book-half section-icon"></i>
                Book Requests
                <i className="bi bi-chevron-down acc-arrow ms-auto"></i>
              </button>
            </h2>

            <div
              id="bookRequests"
              className="accordion-collapse collapse"
              data-bs-parent="#profileAccordion"
            >
              <div className="accordion-body fade-in">

                {bookRequests.length === 0 ? (
                  <p className="text-muted text-center">No pending requests</p>
                ) : (
                  <ul className="list-group">
                    {bookRequests.map((req) => (
                      <li key={req._id} className="request-card">

                        <div className="request-info">
                          <strong className="request-title">{req.bookName}</strong>
                          <p className="request-role">Role: {req.role}</p>
                        </div>

                        <div className="request-buttons-row">
                          <button
                            className="btn btn-accept-modern ripple"
                            onClick={() => handleRequestAction(req._id, "accept")}
                          >
                            <i className="bi bi-check-circle-fill me-1"></i> Accept
                          </button>

                          <button
                            className="btn btn-reject-modern ripple"
                            onClick={() => handleRequestAction(req._id, "reject")}
                          >
                            <i className="bi bi-x-circle-fill me-1"></i> Reject
                          </button>
                        </div>

                      </li>


                    ))}
                  </ul>
                )}

              </div>
            </div>
          </div>

        </div>
        {/* DOWNLOAD APK BUTTON */}
        <div className="profile-card mt-4 hover-tile">
          <button
            className="btn btn-download-apk ripple w-100"
            onClick={() => {
              localStorage.setItem("gradezy_app_installed", "yes");
              window.open("https://cashify.gradezy.in/Cashify.apk", "_blank");
            }}
          >
            <i className="bi bi-cloud-arrow-down-fill me-2"></i> Download APK
          </button>
        </div>


        {/* LOGOUT BUTTON */}
        <div className="profile-card mt-4 hover-tile">
          <button className="btn btn-logout ripple w-100" onClick={logout}>
            <i className="bi bi-box-arrow-right me-2"></i> Logout
          </button>
        </div>

      </div>

      <BottomNav />
    </div>
  );

};

export default MyProfile;
